import React, { useEffect, useRef } from 'react';

import { loadScript } from '../../../util/script';
import InvestorBlock from '../InvestorBlock';

interface IProps {
  title: string;
  anchor: string;
  lang: string;
}

function StockInfo(props: IProps) {
  const { title, anchor, lang } = props;

  const stockContainer = useRef<HTMLIFrameElement | null>(null);
  const loadingScript = useRef<Promise<void>>();

  const html = `
    <div eqswidget data-domain="charts3.equitystory.com" data-category="teaser" data-company="meituan-v31" data-tool="teaser" data-lang="${lang}" data-querystring="" data-params="" data-overlaycolor="rgba(255, 255, 255, 0.5)" data-loadercolor="rgba(255, 64, 31, 0.5)"></div>
  `;

  useEffect(() => {
    const iframe: HTMLIFrameElement | undefined = stockContainer.current?.children[0]?.children[0] as HTMLIFrameElement;

    if (!iframe) {
      if (loadingScript.current) return;

      const src = 'https://charts3.equitystory.com/widget/loader.js';
      loadingScript.current = loadScript(`${src}?_t=${new Date().getTime()}`);
    } else {
      const { src } = iframe;

      iframe.setAttribute(
        'src',
        src.replace(/^(.*)(English|ChineseTraditional|ChineseSimple)\/$/g, (_, p1) => {
          return `${p1}${lang}/`;
        }),
      );
    }
  }, [lang]);

  return (
    <InvestorBlock title={title} anchor={anchor}>
      <div
        className="overflow-hidden rounded-[12px] bg-[#fff]"
        ref={stockContainer}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </InvestorBlock>
  );
}

export { StockInfo };
